import React, { useLayoutEffect, useRef } from "react";
import PropTypes from "prop-types";
import { eventShape } from "./shapes";

const FRAME_HEIGHT_PROPERTY = "--timeline-figure-height";

function Event({
  id,
  date,
  dateObj,
  body,
  imageDefault,
  imageRetina,
  credit,
  alt,
  onClick,
  nextDate,
}) {
  const showImage = imageDefault;
  const imageFrame = useRef(null);

  // Set a custom propery that the caption can use to declare its height.
  // This is necessary because the image is absolutely positioned, causing the
  // height of the figure to be set by the caption length
  useLayoutEffect(() => {
    if (!imageFrame) return null;
    const height = imageFrame.current.getBoundingClientRect().height;
    document.documentElement.style.setProperty(
      FRAME_HEIGHT_PROPERTY,
      `${height}px`
    );
  });

  return (
    <div
      className="m-slide"
      id={`${id}-panel`}
      role="tabpanel"
      aria-labelledby={`${id}-tab`}
    >
      <div className="m-grid m-timeline-event">
        <div className="m-grid__item m-grid__item--5">
          <h3 className="m-timeline-event__heading">{dateObj.getFullYear()}</h3>
          <div
            className="m-timeline-event__body m-rte"
            dangerouslySetInnerHTML={{ __html: body }}
          />
          {nextDate && (
            <button
              className="m-link-underlined m-timeline-event__next-button"
              onClick={onClick}
            >
              {`Continue to ${nextDate}`}
            </button>
          )}
        </div>
        {imageDefault && (
          <figure className="m-grid__item m-grid__item--7 m-timeline-event__figure">
            <div className="m-image-frame a-bg-blue">
              <div
                ref={imageFrame}
                className="m-image-frame__ratio m-image-frame__ratio--5-4"
              ></div>
              <img
                data-flickity-lazyload-srcset={`
                  ${imageRetina || imageDefault} 2x,
                  ${imageDefault} 1x`}
                data-flickity-lazyload-src={imageDefault}
                alt={alt}
                className="m-timeline-event__image m-image"
              />
            </div>
            <figcaption className="m-timeline-event__caption">
              {credit}
            </figcaption>
          </figure>
        )}
      </div>
    </div>
  );
}

Event.displayName = "Timeline.Slider.Event";

Event.propTypes = {
  ...eventShape,
  id: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  nextDate: PropTypes.number,
};

export default Event;
